export default __webpack_public_path__ + "static/media/cr.b226872e.svg";